import { useMemo } from "react";
import { PermissionTypes } from "@certa/types";
import { CERTA_SUPPORT } from "../constants";
import type { Kind } from "@certa/types";
import { useKinds } from "@certa/queries/hooks/kinds.hooks";
import { get as lodashGet } from "lodash-es";
import { useFilterHeaderOptionBasedOnUserGroup } from "./useFilterHeaderOptionBasedOnUserGroup";
import { useCheckPermission } from "../utils/permissions/Chowkidar";
import { useInstanceConfigQuery } from "@certa/queries/hooks/config.hook";
import type { InstanceConfiguration } from "@certa/queries/types/config.types";

export const useCanSeeCreateSupportButton = () => {
  const { data: kinds } = useKinds();

  const { data: config } = useInstanceConfigQuery();
  const canCreateSupportTicketConfig = lodashGet(
    config,
    "custom_ui_labels.create_support_ticket",
    {} as InstanceConfiguration["custom_ui_labels"]["create_support_ticket"]
  );

  const supportTicketKind = useMemo(
    () =>
      kinds?.find(
        (kind: Kind) =>
          kind.tag === CERTA_SUPPORT && kind.features.includes("add_workflow")
      ),
    [kinds]
  );
  const hasAddWorkflowPermission = useCheckPermission(
    PermissionTypes.CAN_ADD_WORKFLOW
  );

  const createSupportTicketOption = useFilterHeaderOptionBasedOnUserGroup([
    canCreateSupportTicketConfig
  ]);
  const supportTicketData =
    supportTicketKind &&
    hasAddWorkflowPermission &&
    createSupportTicketOption.length
      ? createSupportTicketOption[0]
      : null;

  return {
    supportTicketData,
    supportTicketKind
  };
};
